import React from 'react'

const Footer  = () => {
  return (
    <footer className='bg-stone-800  flex  text-sky-400 justify-center rounded m-1 py-3'><a href="https://thenishantkumar.in"> My Portfolio &nbsp;&nbsp;Made with 💖 Nishant </a> </footer>
  )
}

export default Footer